import WarningMobile from "./warning_mobile";
export default WarningMobile